import React from "react";
import FeatureSection from "./FeatureSection";

const FeatureSectionPage = () => {
  return (
    <main className="min-h-screen bg-white">
        <header className="text-sm text-white py-4 sm:py-6 bg-blue-900 shadow-md">
  <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-0">
    
    {/* 🔹 Left: Logo + Tagline */}
    <div className="flex flex-col items-center sm:items-start">
      <div className="flex items-center gap-2">
        <img
          src="/image1.png"
          alt="Logo"
          className="h-12 w-12 sm:h-16 sm:w-16 rounded-full shadow"
        />
        <h1 className="text-xl sm:text-2xl font-bold italic whitespace-nowrap">
          <span className="text-white">League</span>
          <span className="text-red-500">Sphere</span>
        </h1>
      </div>
      <span className="text-purple-200 italic text-xs sm:text-sm">
        Plan. Promote. Play
      </span>
    </div>
    </div>
</header>
      <FeatureSection />
    </main>
  );
};

export default FeatureSectionPage;